/**
 * kaynak-referans @tebhos/constants EmojiConstants paritesi (1:1 port).
 *
 * Ten rengi (skin tone) surrogate karakterleri — Fitzpatrick tip 1-2..6
 * sırasında. UnicodeEmojis diversity indeksi bu sırayı kullanır
 * (skin-tone-1..skin-tone-5 adları dizideki konumdan türer).
 */
export const SKIN_TONE_SURROGATES = ["🏻", "🏼", "🏽", "🏾", "🏿"] as const;
